import { render } from "./CatchmentAreaInformation.vue?vue&type=template&id=3dfab002&ts=true"
import script from "./CatchmentAreaInformation.vue?vue&type=script&lang=ts"
export * from "./CatchmentAreaInformation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__